export enum ModeType {
  Demo = '0',
  Develop = '1',
  Qa = '2',
  Prod = '3',
  Uat = '4',
  Custom = '5',
  Feature1 = '6',
  Mock = '7',
  Staging = '8',
  Prod2 = '9',
  Staging2 = '10',
  Qa2 = '11',
  Aramark_Prod = '14',
  Aramark_Staging = '15',
}
